import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight, Loader2 } from "lucide-react";
import { Img } from "../components/common/Img";
import { ArticleModal } from "../components/modals/Modals";
import { articleService, resolveImageUrl } from "../services/catalogService";
import { useLanguage } from "../context/LanguageContext";

// Task 12 — full blog listing (all admin-managed articles).
export default function BlogPage() {
  const { t, localize } = useLanguage();
  const [articles, setArticles] = useState(null);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    articleService.list().then(setArticles).catch(() => setArticles([]));
  }, []);

  return (
    <main className="min-h-screen bg-[#F6F2EC] text-[#252525] pt-28 pb-24" data-testid="blog-page">
      <div className="container-tessa">
        <Link to="/" className="flex w-fit items-center gap-2 text-[12px] uppercase tracking-[0.16em] text-[#817B74] hover:text-[#D92A47] transition-colors mb-10">
          <ArrowLeft size={14} /> {t("pages.backHome")}
        </Link>
        <span className="font-sans text-xs uppercase tracking-[0.24em] text-[#D92A47]">{t("news.eyebrow")}</span>
        <h1 className="font-serif text-5xl md:text-6xl leading-[0.95] mt-3 mb-12">{t("pages.blog.title")}</h1>

        {articles === null ? (
          <div className="text-[#817B74] py-20 text-center"><Loader2 className="animate-spin inline mr-2" size={16} />{t("pages.loading")}</div>
        ) : articles.length === 0 ? (
          <div className="border border-black/10 bg-white p-12 text-center" data-testid="blog-empty">
            <p className="font-serif text-2xl">{t("pages.blog.empty")}</p>
          </div>
        ) : (
          <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="blog-list">
            {articles.map((article) => (
              <li key={article.id}>
                <button onClick={() => setSelected(article)} data-testid={`blog-article-${article.id}`} className="group text-left w-full">
                  <div className="relative aspect-[4/3] overflow-hidden bg-[#EDE8E0]">
                    {article.image && (
                      <Img src={resolveImageUrl(article.image)} alt={localize(article, "title")}
                        className="h-full w-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105" />
                    )}
                  </div>
                  <div className="mt-4 flex items-center gap-3 text-[11px] uppercase tracking-[0.16em] text-[#D92A47]">
                    <span>{localize(article, "category")}</span>
                    <span className="text-[#817B74]">· {article.date}</span>
                  </div>
                  <h2 className="mt-2 font-serif text-2xl leading-tight text-[#252525] transition-colors group-hover:text-[#D92A47]">
                    {localize(article, "title")}
                  </h2>
                  <p className="mt-2 text-[15px] leading-relaxed text-[#817B74]">{localize(article, "excerpt")}</p>
                  <span className="mt-3 inline-flex items-center gap-2 text-[12px] font-semibold uppercase tracking-[0.14em] text-[#252525]">
                    {t("pages.blog.read")} <ArrowRight size={15} className="transition-transform group-hover:translate-x-1" />
                  </span>
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>

      <ArticleModal article={selected} open={Boolean(selected)} onClose={() => setSelected(null)} />
    </main>
  );
}
